import get from 'transmute/get';
import { BOT_ID } from '../constants/keyPaths';
export const getBotId = get(BOT_ID);